var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { artDetailsCls, artDetailsItemCls, artDetailsListItemCls, artDetailsLabelCls } from "./Details.less";
var ArtDetails = /* @__PURE__ */ __name(function ArtDetails2(_ref) {
  var children = _ref.children, _ref$nodeType = _ref.nodeType, Component = _ref$nodeType === void 0 ? "div" : _ref$nodeType;
  return /* @__PURE__ */ React.createElement(Component, {
    className: artDetailsCls
  }, children);
}, "ArtDetails");
var ArtDetailsItem = /* @__PURE__ */ __name(function ArtDetailsItem2(_ref2) {
  var name = _ref2.name, _ref2$separator = _ref2.separator, separator = _ref2$separator === void 0 ? " | " : _ref2$separator, children = _ref2.children;
  return /* @__PURE__ */ React.createElement("li", {
    className: artDetailsItemCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: artDetailsLabelCls
  }, name, separator), /* @__PURE__ */ React.createElement("span", null, children));
}, "ArtDetailsItem");
var ArtDetailsListItem = /* @__PURE__ */ __name(function ArtDetailsListItem2(_ref3) {
  var children = _ref3.children;
  return /* @__PURE__ */ React.createElement("li", {
    className: artDetailsListItemCls
  }, children);
}, "ArtDetailsListItem");
export {
  ArtDetails,
  ArtDetailsItem,
  ArtDetailsListItem
};
